import React from "react";
import {
  UPGRADE_DEVICES_FIRMWARE,
  UPGRADE_DEVICES,
  DOWNGRADE_DEVICES,
  CANCEL_UPGRADE,
} from "redux-store/devices";

export const OpType = Object.freeze({
  UPGRADE_FIRMWARE: 0,
  UPGRADE_PLAYER: 1,
  DOWNGRADE_PLAYER: 2,
  UPGRADE_AGENT: 3,
  UPGRADE_WEBOS: 4,
  CANCEL_UPGRADE: 5,
});

export const UpgradeConfig = [
  {
    id: OpType.UPGRADE_FIRMWARE,
    label: "Upgrade Firmware",
    showInOperationDropdown: false,
    showVersionDropdown: false,
    isUpgrade: true,
    actionType: UPGRADE_DEVICES_FIRMWARE,
    title: "Upgrade Firmware",
    currentVersionLabel: "Current Firmware",
    currentVersionField: "current_firmware",
    targetVersionLabel: "Latest firmware",
    targetVersionField: "latest_firmware",
    submitButtonLabel: "Upgrade Firmware",
    deviceHelpText:
      "Required. Please select the target devices you want to perform this operation on. " +
      "You can select individual devices as well as tags. " +
      "Only devices using an older version will appear.",
    topWarning: "",
    popupWarning: (
      <div>
        <strong>Upgrade Firmware, are you sure?</strong>
        <br />
        You will <em>not</em> be able to revert this change. Please double check
        the device list before you proceed.
      </div>
    ),
    successMessage:
      "Device firmware upgrade request processed " +
      "successfully. Your devices will be upgraded shortly.",
  },
  {
    id: OpType.UPGRADE_PLAYER,
    label: "Upgrade Player (Linux and Windows devices)",
    showInOperationDropdown: true,
    showVersionDropdown: true,
    isUpgrade: true,
    actionType: UPGRADE_DEVICES,
    title: "Upgrade Players",
    currentVersionLabel: "Current Version",
    currentVersionField: "current_version",
    targetVersionLabel: "Upgrade version",
    targetVersionField: "upgrade_version",
    submitButtonLabel: "Upgrade Players",
    deviceHelpText:
      "Required. Please select the target devices you want to perform this operation on. " +
      "You can select individual devices as well as tags. " +
      "Only devices using an older version will appear.",
    topWarning: "",
    popupWarning: (
      <div>
        <strong>Upgrade Cortex?</strong>
        <br />
        You can only downgrade to select versions of the player; you may not be
        able to revert this change. Please double-check the device list before
        you proceed.
      </div>
    ),
    successMessage:
      "Device software upgrade request processed " +
      "successfully. Your devices will be upgraded shortly.",
  },
  {
    id: OpType.DOWNGRADE_PLAYER,
    label: "Downgrade Player (Linux and Windows devices)",
    showInOperationDropdown: true,
    showVersionDropdown: true,
    isUpgrade: false,
    actionType: DOWNGRADE_DEVICES,
    title: "Downgrade Players",
    currentVersionLabel: "Current Version",
    currentVersionField: "current_version",
    targetVersionLabel: "Downgrade Version",
    targetVersionField: "downgrade_version",
    submitButtonLabel: "Downgrade Players",
    deviceHelpText:
      "Required. Please select the target devices you want to perform this operation on. " +
      "You can select individual devices as well as tags. " +
      "Only devices using a newer version will appear.",
    topWarning: (
      <div>
        Please check the{" "}
        <a
          href="https://help.vistarmedia.com/hc/en-us/articles/25429813636877-Cortex-Release-Notes"
          style={{ textDecoration: "underline" }}
        >
          player release notes
        </a>{" "}
        to see what updates and bug fixes you'll miss, and double-check the
        device list before you proceed.
      </div>
    ),

    popupWarning: (
      <div>
        <strong>Are you sure you want to downgrade Cortex?</strong>
        <br />
        Please check the{" "}
        <a
          href="https://help.vistarmedia.com/hc/en-us/articles/25429813636877-Cortex-Release-Notes"
          style={{ textDecoration: "underline" }}
        >
          player release notes
        </a>{" "}
        to see what updates and bug fixes you'll miss, and double-check the
        device list before you proceed.
      </div>
    ),
    successMessage:
      "Device software downgrade request processed " +
      "successfully. Your devices will be downgraded shortly.",
  },
  {
    id: OpType.UPGRADE_AGENT,
    label: "Upgrade Agent",
    showInOperationDropdown: true,
    showVersionDropdown: false,
    isUpgrade: true,
    actionType: UPGRADE_DEVICES,
    title: "Upgrade Agents",
    currentVersionLabel: "Current Version",
    currentVersionField: "current_version",
    targetVersionLabel: "Latest Version",
    targetVersionField: "latest_version",
    submitButtonLabel: "Upgrade Agents",
    deviceHelpText:
      "Required. Please select the target devices you want to perform this operation on. " +
      "You can select individual devices as well as tags. " +
      "Only devices using an older version will appear.",
    topWarning: "",
    popupWarning: (
      <div>
        <strong>Upgrade Agent, are you sure?</strong>
        <br />
        You will <em>not</em> be able to revert this change. Please double check
        the device list before you proceed.
      </div>
    ),
    successMessage:
      "Device agent upgrade request processed " +
      "successfully. Your devices will be upgraded shortly.",
  },
  {
    id: OpType.UPGRADE_WEBOS,
    label: "Upgrade Player (webOS devices)",
    showInOperationDropdown: true,
    showVersionDropdown: false,
    isUpgrade: true,
    actionType: UPGRADE_DEVICES,
    title: "Upgrade Players",
    currentVersionLabel: "Current Version",
    currentVersionField: "current_version",
    targetVersionLabel: "Latest Version",
    targetVersionField: "latest_version",
    submitButtonLabel: "Upgrade Players",
    deviceHelpText:
      "Required. Please select the target devices you want to perform this operation on. " +
      "You can select individual devices as well as tags. " +
      "Only devices using an older version will appear.",
    topWarning: "",
    popupWarning: (
      <div>
        <strong>Upgrade WebOS, are you sure?</strong>
        <br />
        You will <em>not</em> be able to revert this change. Please double check
        the device list before you proceed.
      </div>
    ),
    successMessage:
      "Device WebOS upgrade request processed " +
      "successfully. Your devices will be upgraded shortly.",
  },
  {
    id: OpType.CANCEL_UPGRADE,
    label: "Cancel Pending Up/Downgrade",
    showInOperationDropdown: true,
    showVersionDropdown: false,
    isUpgrade: true,
    actionType: CANCEL_UPGRADE,
    title: "Cancel Pending Up/Downgrade",
    currentVersionLabel: "Current Version",
    currentVersionField: "current_version",
    targetVersionLabel: "Pending Version",
    targetVersionField: "target_version",
    submitButtonLabel: "Cancel Upgrades/Downgrades",
    deviceHelpText:
      "Required. Please select the target devices you want to perform this operation on. " +
      "You can select individual devices as well as tags. " +
      "Only devices waiting to upgrade or downgrade will appear.",
    topWarning: "",
    popupWarning: (
      <div>
        <strong>Cancel pending upgrades/downgrades?</strong>
        <br />
        Devices that are offline or have installation issues will stay on their
        current version. Please review the device list before proceeding.
      </div>
    ),
    successMessage:
      "The request to cancel pending upgrades or downgrades was successful. " +
      "Devices that are offline or have installation issues will stay on their current version.",
  },
];
